import ScrollToSection from './ScrollToSection';
import Nav from './components/Nav';
import Hero from './components/Hero';
import CostOfStack from './components/CostOfStack';
import WhatRcrt from './components/WhatRcrt';
import StudioDemo from './components/StudioDemo';
import StackCalculator from './components/StackCalculator';
import CaseStudy from './components/CaseStudy';
import Products from './components/Products';
import BuildWithSdk from './components/BuildWithSdk';
import Category from './components/Category';
import Cta from './components/Cta';
import Footer from './components/Footer';

export default function App() {
  return (
    <>
      <ScrollToSection />
      <Nav />
      <main>
        <Hero />
        <CostOfStack />
        <WhatRcrt />
        <StudioDemo />
        <StackCalculator />
        <CaseStudy />
        <Products />
        <BuildWithSdk />
        <Category />
        <Cta />
      </main>
      <Footer />
    </>
  );
}
